__webpack_require__.p = "https://ocr-demo-1254418846.cos.ap-guangzhou.myqcloud.com/ocr-demo-chatocr/";